module.exports = __webpack_public_path__ + "static/media/image_8.94fae9c6.png";